import { SitePlanDevices as SitePlanDevicesComponent, Header } from "components"

export const SitePlanDevices = () => {
 return (
  <>
   <Header />
   <SitePlanDevicesComponent />
  </>
 )
}
